module.exports = __webpack_public_path__ + "static/media/  (6).f390abd0.jpg";